import { apiClient } from './client'

export type GoogleRating = {
  rating: number
  total: number
  updated_at: string | null
  source: 'google' | 'fallback'
}

export async function getGoogleRating(): Promise<GoogleRating> {
  const { data } = await apiClient.get<GoogleRating>('/api/google/rating')
  return data
}
